import DataGrid, { Column, RenderCellProps, RenderCheckboxProps, RenderGroupCellProps, RenderHeaderCellProps, RenderSummaryCellProps, TreeDataGrid, useRowSelection } from "react-data-grid";
// import { groupBy as rowGrouper } from 'lodash-es';
import { DataRow } from '../../stores/TabsStore';
import { useAppStore } from '../../stores/RootStore';

import './styles.css';
import { Dispatch, SetStateAction, useState } from "react";

export type GroupingState = string[];

export interface ColumnSort {
  desc: boolean;
  id: string;
}
export type SortingState = ColumnSort[];

export interface SummaryRow {
  id: string; 
  totalCount: number; 
  worked: string; 
  stopped: string; 
  turnedOff: string,
  personnel: number,
  // interactionsAsDuration: string, 
  // equipmentStartViolation: string,
  // equipmentEndViolation: string
}

type Comparator = (a: DataRow, b: DataRow) => number;

export function getComparator(sortColumn: string): Comparator {
  switch (sortColumn) {
    case 'at':
      return (a, b) => {
        return a.dateShift.start_day.toSeconds()! - b.dateShift.start_day.toSeconds()!;
      };
    case 'weekday':
      return (a, b) => {
        return a.dateShift.start_day.weekdayShort!.localeCompare(b.dateShift.start_day.weekdayShort!);
      };
    case 'shiftName':
      return (a, b) => {
        return a.dateShift.label!.localeCompare(b.dateShift.label!);
      };
    case 'division_name':
    case 'name':
    case 'equipment_model_name':
    case 'inventory_number':
      return (a, b) => {
        return a.equipment.attributes[sortColumn]!.localeCompare(b.equipment.attributes[sortColumn]!);
      };
    case 'last_name':
      return (a, b) => {
        return a.person!.attributes[sortColumn]!.localeCompare(b.person!.attributes[sortColumn]!);
      };
    // case 'available':
    //   return (a, b) => {
    //     return a[sortColumn] === b[sortColumn] ? 0 : a[sortColumn] ? 1 : -1;
    //   };
    case 'worked':
    case 'stopped':
    case 'off':
      return (a, b) => {
        return a.availability[sortColumn].seconds! - b.availability[sortColumn].seconds!;
      };
    default:
      throw new Error(`unsupported sortColumn: "${sortColumn}"`);
  }
}

interface Props {
  columns: readonly Column<DataRow, any>[],
  selectedRows: ReadonlySet<number>,
  setSelectedRows: Dispatch<SetStateAction<ReadonlySet<number>>>,
  rows: readonly DataRow[]
  summaryRows: readonly any[]
  groupByColumns: string[],
  sortByColumns: SortingState,
}

function rowKeyGetter(row: DataRow) { return row.id;}

export function ReportTableDataGrid({
  columns, 
  groupByColumns,
  rows, 
  selectedRows,
  setSelectedRows,
  summaryRows
}:Props) {
  const [expandedGroupIds, setExpandedGroupIds] = useState((): ReadonlySet<unknown> => new Set<unknown>([]));

  return (<>
    {groupByColumns.length > 0 ? 
      <TreeDataGrid 
        className='rdg h-full text-sm'
        columns={columns}
        rows={rows}
        rowKeyGetter={rowKeyGetter}
        selectedRows={selectedRows}
        onSelectedRowsChange={setSelectedRows}
        groupBy={groupByColumns}
        rowGrouper={rowGrouper}
        expandedGroupIds={expandedGroupIds}
        onExpandedGroupIdsChange={setExpandedGroupIds}
        defaultColumnOptions={{ resizable: true }}
      />
      :
      <DataGrid 
        className='rdg h-full w-full text-sm'
        columns={columns}
        headerRowHeight={34}
        summaryRowHeight={40}
        selectedRows={selectedRows}
        onSelectedRowsChange={setSelectedRows}
        bottomSummaryRows={summaryRows}
        rows={rows}
        rowKeyGetter={rowKeyGetter}
      />
    }
  </>)
}

function rowGrouper(rows: readonly DataRow[], columnKey: string) {
  switch (columnKey) {
    case "at":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.dateShift.start_day.ts) as Record<string, readonly R[]>;
    case "shift":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.dateShift.id) as Record<string, readonly R[]>;
    case "weekday":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.dateShift.start_day.weekday) as Record<string, readonly R[]>;
    case "equipment":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.equipment.id) as Record<string, readonly R[]>;
    case "equipment_model":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.equipment.attributes.equipment_model_id) as Record<string, readonly R[]>;
    case "equipment_type":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.equipment.attributes.equipment_type_id) as Record<string, readonly R[]>;
    case "division":
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r.equipment.attributes.division_id) as Record<string, readonly R[]>;
  
    default:
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return Object.groupBy(rows, (r) => r[columnKey]) as Record<string, readonly R[]>;
  }
}







